import { render, staticRenderFns } from "./cardVirtualConversationTest.vue?vue&type=template&id=1b346500"
import script from "./cardVirtualConversationTest.vue?vue&type=script&lang=js"
export * from "./cardVirtualConversationTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports